import { Grid } from "@material-ui/core";
import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./ChangePassword.scss";
import { Text, Modal, SVG, PasswordInput, Button } from "sunrise-ui";
import { putChangePassword } from "../../redux/reducers/profile";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../utilities/Loader";

const ChangePassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [currentPassword, setCurrentPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  // --------input field error handler state----------
  const [currentPasswordErr, setCurrentPasswordErr] = React.useState(false);
  const [newPasswordErr, setNewPasswordErr] = React.useState(false);
  const [confirmPasswordErr, setConfirmPasswordErr] = React.useState(false);
  const [isMatched, setIsMatched] = React.useState(true);

  //-----------password visibility state-----------
  const [isCurrentPasswordVisible, setCurrentPasswordVisible] =
    React.useState(false);
  const [isNewPasswordVisible, setNewPasswordVisible] = React.useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] =
    React.useState(false);

  //-----modal state--------
  const [open, setOpen] = React.useState(false);

  //------modal handler
  const handleModal = () => {
    setOpen(true);
  };
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);

  //------submit/continue button and error handler----
  const handleSubmit = () => {
    let goodToGo = true;
    if (
      currentPassword === "" ||
      currentPassword === null ||
      currentPassword === undefined ||
      currentPassword?.length < 8
    ) {
      goodToGo = false;
      setCurrentPasswordErr(true);
    }
    if (
      newPassword === "" ||
      newPassword === null ||
      newPassword === undefined ||
      newPassword?.length < 8
    ) {
      goodToGo = false;
      setNewPasswordErr(true);
    }
    if (
      confirmPassword === "" ||
      confirmPassword === null ||
      confirmPassword === undefined ||
      confirmPassword?.length < 8
    ) {
      goodToGo = false;
      setConfirmPasswordErr(true);
    }
    if (
      confirmPassword !== "" &&
      newPassword !== "" &&
      confirmPassword?.length > 7 &&
      newPassword?.length > 7 &&
      newPassword !== confirmPassword
    ) {
      goodToGo = false;
      setIsMatched(false);
    }
    if (goodToGo === true) {
      handleModal();
    }
  };

  //----modal YES button handler
  const handleCall = () => {
    if (loading === false) {
      const credentials = {
        currentPassword,
        newPassword,
        confirmPassword,
      };
      setOpen(false);
      const userId = sessionStorage.getItem("userID");
      setLoading(true);
      dispatch(
        putChangePassword({
          endPoint: `general/change-password/${userId}`,
          data: credentials,
        })
      ).then((res) => {
        setLoading(false);
      });
    }
  };
  const changePassData = useSelector(
    (state: any) => state.PROFILE.changePasswordData
  );
  React.useEffect(() => {
    if (changePassData?.status) {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [changePassData]);
  return (
    <Sidebar>
      <Grid container className="changePassword_wrapper">
        <Grid item xs={12} md={6}>
          <Grid className="left">
            <Grid xs={12} item>
              <Text
                type="normal"
                fonts="normal"
                fontSize={20}
                className="mb0 mt0 change-password-text"
              >
                Change Password
              </Text>
            </Grid>
            {/* ----SVG image------ */}
            <Grid xs={12} item className="d-flex h-center v-center">
              <Grid className="mb1 mt1">
                <SVG type={"changePasswordImg"}></SVG>
              </Grid>
            </Grid>
            {/* ----Current password input------ */}
            <Grid xs={12} item>
              <Grid className="mb1">
                <Text type={"normal"} fontSize={16} fonts={"normal"}>
                  Current Password*
                </Text>
                <PasswordInput
                  color={`${currentPasswordErr ? "danger" : "primary"}`}
                  lock={!currentPasswordErr}
                  placeholder="Enter Current Password"
                  value={currentPassword}
                  maxLength={16}
                  minLength={8}
                  isPasswordVisible={isCurrentPasswordVisible}
                  onIconClick={() =>
                    setCurrentPasswordVisible(!isCurrentPasswordVisible)
                  }
                  onChange={(e: any) => {
                    setCurrentPassword(e.target.value);
                    setCurrentPasswordErr(false);
                  }}
                />
                <Text
                  type={currentPasswordErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    currentPasswordErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Current Password
                </Text>
              </Grid>
            </Grid>
            {/* ----New password input------ */}
            <Grid xs={12} item>
              <Grid className="mb1">
                <Text type={"normal"} fontSize={16} fonts={"normal"}>
                  New Password*
                </Text>
                <PasswordInput
                  color={`${
                    newPasswordErr || !isMatched ? "danger" : "primary"
                  }`}
                  lock={!newPasswordErr}
                  placeholder="Enter New Password"
                  value={newPassword}
                  maxLength={16}
                  minLength={8}
                  isPasswordVisible={isNewPasswordVisible}
                  onIconClick={() =>
                    setNewPasswordVisible(!isNewPasswordVisible)
                  }
                  onChange={(e: any) => {
                    setNewPassword(e.target.value);
                    setNewPasswordErr(false);
                    setIsMatched(true);
                  }}
                />
                <Text
                  type={newPasswordErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={newPasswordErr ? "mb0 mt0 float-right" : "d-none"}
                >
                  Please Enter New Password of Valid Length
                </Text>
              </Grid>
            </Grid>
            {/* ----confirm password input------ */}
            <Grid xs={12} item>
              <Grid className="mb1">
                <Text type={"normal"} fontSize={16} fonts={"normal"}>
                  Confirm Password*
                </Text>
                <PasswordInput
                  color={`${
                    confirmPasswordErr || !isMatched ? "danger" : "primary"
                  }`}
                  lock={!confirmPasswordErr}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  maxLength={16}
                  minLength={8}
                  isPasswordVisible={isConfirmPasswordVisible}
                  onIconClick={() =>
                    setConfirmPasswordVisible(!isConfirmPasswordVisible)
                  }
                  onChange={(e: any) => {
                    setConfirmPassword(e.target.value);
                    setConfirmPasswordErr(false);
                    setIsMatched(true);
                  }}
                />
                <Text
                  type={confirmPasswordErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    confirmPasswordErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Confirm Password of Valid Length
                </Text>
                <Text
                  type={!isMatched ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={!isMatched ? "mb0 mt0 float-right" : "d-none"}
                >
                  Entered Password is not matching
                </Text>
              </Grid>
            </Grid>
            {/* ----submit Button------ */}
            <Grid container>
              <Grid xs={12} item>
                <Grid className="">
                  <Modal
                    image="modalImage"
                    call={() => {
                      handleCall();
                    }}
                    reset={() => {
                      setOpen(false);
                    }}
                    openModal={open}
                    title="Are you sure you want to change the password?"
                    showImageModal={false}
                  />
                </Grid>
                <Grid className="d-flex h-center w100 mb2">
                  <Button
                    className="w100"
                    isRounded={true}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {loading ? (
                      <Loader
                        color="#fff"
                        loading={loading}
                        size={8}
                        height="auto"
                      />
                    ) : (
                      "Continue"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} className="d-flex h-center v-center">
          <Grid className="right">
            <Text type={"normal"} fontSize={20} fonts={"normal"}>
              <span className="fw-500">Password</span>
            </Text>
            <p>
              <span
                className="iconify text--primary mr f10 vm"
                data-icon="akar-icons:circle-fill"
              ></span>
              <span className="fw-400">
                Must contain at least one capital letter.
              </span>
            </p>
            <p>
              <span
                className="iconify text--primary mr f10 vm"
                data-icon="akar-icons:circle-fill"
              ></span>
              <span className="fw-400">
                Must contain at least one small letter.
              </span>
            </p>
            <p>
              <span
                className="iconify text--primary mr f10 vm"
                data-icon="akar-icons:circle-fill"
              ></span>
              <span className="fw-400">
                Must contain at least one special character.
              </span>
            </p>
            <p>
              <span
                className="iconify text--primary mr f10 vm"
                data-icon="akar-icons:circle-fill"
              ></span>
              <span className="fw-400">Must have 8 to 16 character long.</span>
            </p>
          </Grid>
        </Grid>
      </Grid>
    </Sidebar>
  );
};

export default ChangePassword;
